<template>
  <div>
    <van-nav-bar title="通知公告" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @refresh="onRefresh"
        @load="onLoad">
        <van-swipe-cell v-for="item in list" :key="item.id" disabled>
          <van-card class="goods-card"
                    @click="">
            <template slot="title">
              <div style="font-weight: bold;font-size: 14px;">{{item.title}}</div>
            </template>
            <template slot="thumb">
              <img :src="listIcon" style="width: 60px;"/>
            </template>
            <template slot="desc">
              <div>{{item.content}}</div>
            </template>
            <template slot="tags">
<!--              <span>加班类型：<van-tag plain type="danger">{{-->
<!--                  workOvertimeTypeFormatter(item.workovertimeType)-->
<!--                }}</van-tag></span><br>-->
<!--              <span>开始时间：{{ item.beginTime }}</span><br>-->
<!--              <span>结束时间：{{ item.endTime }}</span><br>-->
<!--              <span>加班天数：{{ item.day }}</span><br>-->
<!--              <span>加班原因：{{ item.reason }}</span><br>-->
            </template>
            <template slot="footer">
              <div>{{ item.createTime }}</div>
            </template>
          </van-card>
        </van-swipe-cell>
      </van-list>
      <van-empty description="暂无数据" v-if="emptyShow"/>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Toast} from "vant";
import {isLogin, isWechat} from "../../../utils/util";

export default {
  name: "list",
  data() {
    return {
      list: [],
      listIcon: "../../../static/images/email.png",
      loading: false,
      finished: false,
      refreshing: false,
      userId: '',
      userClassify: 0,
      userGroup: 0,
      refereeStatus: 0,
      finishedText: "上滑加载更多...",
      emptyShow: false,
      size: 10,
      current: 1,
      total: 0,
      modelKey: "workovertime",
      processDefinitionId: '',
      processInstanceId: '',
      appNo: '',
      workOvertimeStatusList: [],
      workOvertimeTypeList: [],
      userInfo: {},
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.loading = true;
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.userInfo = user;
          this.getNoticeList();
        }
      );
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      } else {
        this.current++;
      }
      this.getNoticeList();
    },
    onRefresh() {
      // 清空列表数据
      this.current = 1;
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    getNoticeList: function () {
      this.$fetch("/attence-api/blade-notices/notices/page", {
        current: this.current,
        size: this.size,
        type: 1,
        noticeStatus: 2,
        isDeleted: 0
      }).then(
        res => {
          const data = res.data;
          this.list = this.list.concat(data.records);
          this.total = data.total;
          this.size = data.size;
          this.current = data.current;
          if (this.list.length > 0) {
            this.emptyShow = false;
            if (this.total > this.list.length) {
              this.finishedText = "上滑加载更多...";
            } else {
              // 数据全部加载完成
              this.finished = true;
              this.finishedText = "没有更多了";
            }
          } else {
            this.emptyShow = true;
            this.finished = true;
            this.finishedText = "";
          }
          // 加载状态结束
          this.loading = false;
          console.log("返回的数据：" + JSON.stringify(this.list));
        },
        error => {
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          this.finished = true;
        }
      );
    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
  },
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.goods-card {
  margin: 0;
  background-color: @white;
}

.delete-button {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/notice/list.vue